module.exports = __webpack_public_path__ + "static/media/edit_law_grey.5fb9a4bf.svg";